export default "__VITE_ASSET__129b93b0__"